import { StaffAvailability } from 'components/DropdownSelectors/common'
import Translation from 'components/Translation'
import { useAppointmentDrawerContext } from 'context/appointmentDrawerContext/AppointmentDrawerContainer'
import { useTenantContext } from 'context/TenantContext'
import React, { useEffect, useState } from 'react'
import { ServiceApiTypeEnum } from 'types/service'
import { useApiRequest } from 'utils/fetch-helper'
import { addDurationToStr } from 'utils/string-localization-helper'

const AppointmentForm = () => {
    const { getApiRequest } = useApiRequest()
    const {
        formData,
        setFormData,
        availabilityStatus,
        setAvailablilityStatus,
    } = useAppointmentDrawerContext()
    const { locations, services, staff } = useTenantContext()
    const [location_space, setLocationSpace] = useState<any[]>([])

    useEffect(() => {
        if (!formData.location || !formData.staff || !formData.service)
            setFormData({
                ...formData,
                location: locations ? locations[0]?.id : '',
                staff: staff ? staff[0]?.id : '',
                attendees: '0',
                service: services
                    .filter(
                        (item) =>
                            item?.service_type ===
                            ServiceApiTypeEnum.APPOINTMENT
                    )
                    .map((item) => item.id)[0],
            })
    }, [locations?.length, staff, services, formData])

    useEffect(() => {
        getLocationSpaces()
    }, [formData.location])

    const getLocationSpaces = async () => {
        if (locations?.length > 0 && formData?.location.length > 0) {
            const spaces = await getApiRequest(
                `/v1/location-spaces/location-id?locationId=${formData?.location}`
            )
            if (spaces?.content) {
                setLocationSpace([...(spaces?.content as any[])])
                setFormData({ ...formData, space: spaces?.content[0]?.id })
            }
        }
    }

    useEffect(() => {
        if (
            !!formData.date &&
            !!formData.location &&
            !!formData.service &&
            !!formData.staff &&
            !!formData.time
        )
            checkAvailability()
    }, [
        formData.date,
        formData.location,
        formData.service,
        formData.staff,
        formData.time,
    ])

    const checkAvailability = async () => {
        let s = services.find((s) => s.id == formData.service)
        let end_time = addDurationToStr(
            new Date(),
            formData.time,
            s?.duration as number
        )
        const params = [
            `locationId=${formData.location}`,
            `serviceId=${formData.service}`,
            `staffId=${formData.staff}`,
            `date=${formData.date}`,
            `startTime=${formData.time}`,
            `endTime=${end_time}`,
        ]
        const availability = await getApiRequest(
            `/v1/offerings/status/staff?${params.join('&')}`
        )
        let res = StaffAvailability.AVAILABLE
        switch (availability) {
            case StaffAvailability.AVAILABLE:
                res = StaffAvailability.AVAILABLE
                break
            case StaffAvailability.BUSY:
                res = StaffAvailability.BUSY
                break
            case StaffAvailability.NO_AVAILABILITY:
                res = StaffAvailability.NO_AVAILABILITY
                break
            default:
                res = StaffAvailability.AVAILABLE
        }
        setAvailablilityStatus(res)
    }

    const formChangeHandler = (key: string, value: string) => {
        setFormData({ ...formData, [key]: value })
    }

    return (
        <div className="rounded-md">
            <div className="mb-4 text-xl" style={{ color: '#5E9FBD' }}>
                <h1>
                    <Translation content_key="appointment_details" />
                </h1>
            </div>
            <div className="flex justify-between gap-2">
                <div className="flex flex-col w-1/2  form-group">
                    <label className="form-group-label">
                        <Translation content_key="date" />
                    </label>
                    <input
                        required
                        name="date"
                        min={new Date().toLocaleDateString('en-ca')}
                        type={'date'}
                        defaultValue={formData?.date}
                        className="form-control focus:ring-primary-light focus:border-primary-light block shadow-sm border-gray-300 rounded-md mr- w-full"
                        onChange={(e) => {
                            let value = e.target.value
                            formChangeHandler(e.target.name, value)
                        }}
                    />
                </div>
                <div className="flex flex-col w-1/2  form-group">
                    <label className="form-group-label">
                        <Translation content_key="time" />{' '}
                    </label>
                    <input
                        name="time"
                        type={'time'}
                        defaultValue={formData?.time}
                        className=" form-control focus:ring-primary-light focus:border-primary-light block shadow-sm border-gray-300 rounded-md  w-full"
                        onChange={(e) =>
                            formChangeHandler(e.target.name, e.target.value)
                        }
                    />
                </div>
            </div>
            <div className="flex justify-between gap-2 mt-5">
                <div className="flex flex-col w-1/2  form-group">
                    <label className="form-group-label">
                        <Translation content_key="location" />
                    </label>
                    <select
                        name="location"
                        className=" form-control focus:ring-primary-light focus:border-primary-light block shadow-sm border-gray-300 rounded-md  w-full"
                        onChange={(e) =>
                            formChangeHandler(e.target.name, e.target.value)
                        }
                    >
                        {locations.length > 0 ? (
                            locations?.map(
                                (location: any, index: number) => (
                                    <option key={index} value={location.id}>
                                        {location.name}
                                    </option>
                                )
                            )
                        ) : (
                            <option key="no-locations" disabled>
                                No Locations
                            </option>
                        )}
                    </select>
                </div>
                <div className="flex flex-col w-1/2 form-group">
                    <label className="form-group-label">
                        {' '}
                        <Translation content_key="mode_location_space" />{' '}
                    </label>
                    <select
                        name="space"
                        className=" form-control focus:ring-primary-light focus:border-primary-light block shadow-sm border-gray-300 rounded-md  w-full"
                        onChange={(e) =>
                            formChangeHandler(e.target.name, e.target.value)
                        }
                    >
                        {location_space?.map((space) => (
                            <option value={space?.id} key={space?.id}>
                                {space?.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="flex justify-between mt-5">
                <div className="w-full form-group">
                    <label className="form-group-label">
                        <Translation content_key="service" />
                    </label>
                    <select
                        name="service"
                        className=" form-control focus:ring-primary-light focus:border-primary-light block shadow-sm border-gray-300 rounded-md  w-full"
                        onChange={(e) =>
                            formChangeHandler(e.target.name, e.target.value)
                        }
                    >
                        {services
                            ?.filter(
                                (item) =>
                                    item?.service_type ===
                                    ServiceApiTypeEnum.APPOINTMENT
                            )
                            ?.map((service) => (
                                <option
                                    value={service?.id}
                                    key={service?.id}
                                >
                                    {service.name}
                                </option>
                            ))}
                    </select>
                </div>
            </div>
            <div className="mt-5">
                <div className="form-group">
                    <label className="form-group-label">
                        <Translation content_key="staff" />
                    </label>
                    <select
                        name="staff"
                        className=" form-control focus:ring-primary-light focus:border-primary-light block shadow-sm border-gray-300  rounded-md w-full"
                        onChange={(e) =>
                            formChangeHandler(e.target.name, e.target.value)
                        }
                    >
                        {staff?.map((item) => (
                            <option value={item.id} key={item?.id}>
                                {item?.user?.first_name}{' '}
                                {item?.user?.last_name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    )
}

export default AppointmentForm
